import { SelectorSlideshowDesktop } from './SelectorSlideshowDesktop';
import { gsap } from 'gsap';
import { html2dom } from 'libs/lib/dom/create';

class EntitySelectorDesktop extends SelectorSlideshowDesktop {
	constructor(e, b) {
		super(e, b, "EntitySelectorDesktop");
		this.number = this.element.querySelector(".fps-entities-available")

	}

	attach() {
		super.attach()
	}

	detach() {
		super.detach()
	}
	
	slideTemplate = (item) => {
		return `
			<div class="fps-entity fps-slide" data-code="${item.code}">
				<div class="fps-slide-wrapper">
					<div class="fps-pin"></div>
					<div class="fps-slide-name">${item.name}</div>
					<div class="fps-slide-detail">${item.legend}</div>
				</div>
			</div>
		`;
	}

	fill(entities){
		let n = entities.length;
		this.number.innerHTML = `${n} produit${n>1?'s':''} disponible${n>1?'s':''}`;
		if(n > 5) n = n * Math.floor(9 / n + 1)

		const items = [];
		for(let i = 0;i < n;i++) {
			const entity = entities[i % entities.length];
			items.push(html2dom(this.slideTemplate(entity)));
		}


		super.fill(items);
	}
}

export { EntitySelectorDesktop }